import baseUrl from "../constants/baseUrl";
import axios from "axios";

export const applyCoupon = async (tokenPayload) => {
  const { data } = await axios.post(
    `${baseUrl}VisionBookingAPI/ApplyCoupon`,
    tokenPayload
  );
  return data;
};

export const removeCoupon = async (bookingId) => {
  const { data } = await axios.post(
    `${baseUrl}VisionBookingAPI/RemoveCoupon?bookingId=${bookingId}`);
  return data;
};